module.exports = __webpack_public_path__ + "img/mes2.a80be9a9.png";